import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ConsultationDepartmentModel } from '../../models/ConsultationDepartmentModel'


export interface ConsultationDepartmentState {
    ConsultationDepartment: ConsultationDepartmentModel
    ConsultationDepartmentList: ConsultationDepartmentModel[]
}

const initialState: ConsultationDepartmentState = {
    ConsultationDepartment: {} as ConsultationDepartmentModel,
    ConsultationDepartmentList: [],
}

export const ConsultationDepartmentSlice = createSlice({
    name: 'consultationDepartment',
    initialState,
    reducers: {
        setConsultationDepartment: (state, action: PayloadAction<ConsultationDepartmentModel[]>) => {
            state.ConsultationDepartmentList = action.payload
        },
        saveConsultationDepartment: (state, action: PayloadAction<ConsultationDepartmentModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: ConsultationDepartmentModel = { Id: 0, ConsultationDepartmentName: room.ConsultationDepartmentName }
                let currentRoom =
                    state.ConsultationDepartmentList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.ConsultationDepartmentName = room.ConsultationDepartmentName
            } else {
                room.Id = (Math.max(...state.ConsultationDepartmentList.map((c) => c.Id)) || 0) + 1
                state.ConsultationDepartmentList.push(room)
            }
        },
        getConsultationDepartmentById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let ConsultationDepartment: ConsultationDepartmentModel = {} as ConsultationDepartmentModel
            if (id > 0) {
                let currentConsultationDepartment: ConsultationDepartmentModel[] = state.ConsultationDepartmentList
                ConsultationDepartment = currentConsultationDepartment.find((c) => c.Id === id) || ({} as ConsultationDepartmentModel)
            }

            state.ConsultationDepartment = ConsultationDepartment
        },
        deleteConsultationDepartment: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentConsultationDepartment: ConsultationDepartmentModel[] = state.ConsultationDepartmentList
                state.ConsultationDepartmentList = currentConsultationDepartment.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setConsultationDepartment, saveConsultationDepartment, getConsultationDepartmentById, deleteConsultationDepartment } =
ConsultationDepartmentSlice.actions

export default ConsultationDepartmentSlice.reducer
